import { Link } from "react-router-dom";

const ReviewPreview = ({ review }) => {
  const wordLimit = 80;
  const words = review.content.trim().split(" ");
  const isLong = words.length > wordLimit;

  const shortText = words.slice(0, wordLimit).join(" ");

  return (
    <p>
      {isLong ? (
        <>
          {shortText}...{" "}
          <Link to="https://share.google/ZbO83xyagjz5QGhYE" className="text-orange fw-500">
            Read More
          </Link>
        </>
      ) : (
        review.content
      )}
    </p>
  );
};

export default ReviewPreview;
